export enum Page {
    All,
    App,
    Ribbon,
    Layout,
    Print,
    None
}